import { render } from "./CompanyPage.vue?vue&type=template&id=028c66e7"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"

import "./CompanyPage.vue?vue&type=style&index=0&id=028c66e7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__